<ng-progress></ng-progress>
<app-sidenav>
  <app-new-app-alert></app-new-app-alert>
</app-sidenav>
<app-bottom-nav *ngIf="!navData.hasBackButton && !isMerchant"></app-bottom-nav>
